<flowaccount-partner-intro></flowaccount-partner-intro>

<flowaccount-smooth-scroll-anchor-shared
  [styleClass]="'become-our-partner'"
  [contentScully]="'PARTNER_SCROLL_SECTION_LINK_KEY'"
  [contentSquidex]="'partner-scroll-section-link'"
></flowaccount-smooth-scroll-anchor-shared>

<flowaccount-member-each-region></flowaccount-member-each-region>

<flowaccount-partner-roadshow></flowaccount-partner-roadshow>

<flowaccount-carousel-contextual-tabs-shared
  [contentScully]="'CAROUSEL_CONTEXTUAL_TABS_PARTNER_KEY'"
  [contentSquidex]="'carousel-contextual-tabs-partner'"
></flowaccount-carousel-contextual-tabs-shared>

<flowaccount-review-setion
  [bgColorTheme]="'blue-light-bg'"
  [isAccountingImage]="true"
  [customTextList]="reviewSectionTextList"
></flowaccount-review-setion>

<flowaccount-perk-for-partner></flowaccount-perk-for-partner>

<flowaccount-certificate-partners></flowaccount-certificate-partners>

<flowaccount-video-partner-connect></flowaccount-video-partner-connect>

<flowaccount-video-partner-promise></flowaccount-video-partner-promise>

<flowaccount-partner-flowaccount-form></flowaccount-partner-flowaccount-form>

<flowaccount-promotional-banner-squidex
  [contentSquidex]="'partner-product-update-banner'"
  [contentScully]="'PARTNER_PRODUCT_UPDATE_BANNER_KEY'"
  [styleClass]="'become-our-partner'"
  [customId]="'partner-product-update-banner-id'"
></flowaccount-promotional-banner-squidex>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [contentSquidex]="'become-our-partner-blog'"
  [contentScully]="'become-our-partner-blog-key'"
  [styleClass]="'become-our-partner'"
></flowaccount-blog-swiper-squidex>
